import type { EventItem } from '../types';
import { formatSpokenDateTime } from './dateFormat';

export type EventBookingWindowStatus = 'not_yet_open' | 'open' | 'closed';

function parseIsoMs(raw: string | undefined | null): number | null {
  if (raw == null || String(raw).trim() === '') return null;
  const t = new Date(raw).getTime();
  return Number.isNaN(t) ? null : t;
}

/**
 * Uses `bookingStartDate` / `bookingEndDate` from the API. If neither is set, sales are treated as open (legacy events).
 */
export function getEventBookingWindowStatus(
  event: Pick<EventItem, 'bookingStartDate' | 'bookingEndDate'>,
  now: Date = new Date()
): EventBookingWindowStatus {
  const nowMs = now.getTime();
  const startMs = parseIsoMs(event.bookingStartDate);
  const endMs = parseIsoMs(event.bookingEndDate);

  if (startMs == null && endMs == null) return 'open';

  if (startMs != null && nowMs < startMs) return 'not_yet_open';
  if (endMs != null && nowMs > endMs) return 'closed';
  return 'open';
}

/** Spoken-style date & time for when ticket sales open (e.g. "4th of April 2026 at 3:30 pm"). */
export function formatBookingOpensAt(iso: string | undefined | null): string {
  if (iso == null || String(iso).trim() === '') return '';
  return formatSpokenDateTime(iso);
}

export function getBookingClosedUserMessage(event: EventItem, status: EventBookingWindowStatus): string {
  if (status === 'not_yet_open' && event.bookingStartDate) {
    return `Tickets are not on sale yet. They go live on ${formatBookingOpensAt(event.bookingStartDate)}.`;
  }
  if (status === 'closed') {
    return 'Ticket sales for this experience have ended.';
  }
  return '';
}
